import { withInstall } from "../../utils"

import scDescription from './component/ScDescription.vue'

export const ScDescription = withInstall(scDescription);

export * from './hooks/useDescription'